module.exports = __webpack_public_path__ + "static/media/tutorial.460ac74c.png";